import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=941263ba&scoped=true&"
import script from "./ClientFilter.vue?vue&type=script&lang=js&"
export * from "./ClientFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClientFilter.vue?vue&type=style&index=0&id=941263ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941263ba",
  null
  
)

export default component.exports